import { useEffect, useRef } from 'react';

/**
 * Focus a field when the dialog around it opens.
 *
 * The `autoFocus` attribute is the obvious way to write this and the wrong one:
 * it also fires on initial page load, which yanks focus away from wherever the
 * reader was. Doing it in an effect scopes the behaviour to the moment the dialog
 * mounts, which is exactly when moving focus into it is the correct thing to do.
 *
 * Attach the returned ref to the field that should receive focus.
 */
export function useAutoFocus<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);
  return ref;
}
